
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { nanoid } from 'nanoid';
import { Node as ProsemirrorNode } from 'prosemirror-model';

@Component
export default class LinkView extends Vue {
  @Prop() node: ProsemirrorNode;
  isActive = false;
  linkId = nanoid();

  get href(): string {
    return this.node.attrs.href;
  }

  get boundaryElement(): HTMLElement {
    return document.querySelector('#dealroom-document-edit');
  }

  hidePopover({ target }: MouseEvent) {
    if ((target as HTMLElement).id === this.linkId) {
      return;
    }
    this.isActive = false;
  }
}
